/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Settings_TitleInputs */

const en_disabled_websites_settings_title = /** @type {(inputs: Disabled_Websites_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable Settings`)
};

const es_disabled_websites_settings_title = /** @type {(inputs: Disabled_Websites_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de bloqueo`)
};

/**
* | output |
* | --- |
* | "Disable Settings" |
*
* @param {Disabled_Websites_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_settings_title = /** @type {((inputs?: Disabled_Websites_Settings_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Settings_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_settings_title(inputs)
	return en_disabled_websites_settings_title(inputs)
});